import {
  ElementType,
} from 'react';
import {
  EligibilityCheckState,
} from 'dtos/eligibilityCheckState';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import ErrorIcon from '@mui/icons-material/Error';

type EligibilityStateIconConfig = {
  Icon: ElementType;
  className: string;
};

const eligibilityStateConfig: Record<EligibilityCheckState, EligibilityStateIconConfig> = {
  [EligibilityCheckState.ActionRequired]: {
    Icon: ErrorIcon,
    className: 'text-red-500 !text-base',
  },
  [EligibilityCheckState.EncounterCoverageActive]: {
    Icon: CheckCircleIcon,
    className: 'text-green-600 !text-base',
  },
  [EligibilityCheckState.EncounterCoverageInactive]: {
    Icon: DoNotDisturbOnIcon,
    className: 'text-red-400 !text-base',
  },
  [EligibilityCheckState.EncounterCoverageNotFound]: {
    Icon: ErrorIcon,
    className: 'text-amber-500 !text-base',
  },
};

export default eligibilityStateConfig;
